<template>
  <div>
    <label class="field-label d-block mb-2">الإحصائيات (حتى 4)</label>
    <div v-for="(item, idx) in local.items" :key="idx" class="answer-item">
      <div class="answer-item__index">{{ idx + 1 }}</div>
      <div class="answer-item__content">
        <div class="stat-row">
          <InputText v-model="item.number" placeholder="مثال: 2000+" class="w-100" />
          <InputText v-model="item.label" placeholder="مثال: طالب مسجّل" class="w-100" />
        </div>
      </div>
      <div class="answer-item__actions"><button type="button" class="answer-remove-btn" @click="local.items.splice(idx,1)"><i class="pi pi-trash"></i></button></div>
    </div>
    <button type="button" class="add-answer-btn" v-if="local.items.length < 4" @click="local.items.push({ number: '', label: '' })">
      <i class="pi pi-plus"></i> إضافة إحصائية
    </button>
  </div>
</template>

<script setup>
import { reactive, watch } from 'vue';
import InputText from 'primevue/inputtext';

const props = defineProps({ modelValue: { type: Object, default: () => ({}) } });
const emit = defineEmits(['update:modelValue']);

const local = reactive({ items: (props.modelValue.items ?? []).map((i) => ({ ...i })) });

watch(local, () => emit('update:modelValue', { ...props.modelValue, ...local }), { deep: true });
</script>

<style scoped>
.stat-row { display: grid; grid-template-columns: 1fr 1fr; gap: .5rem; }
</style>
